(function () {
  if (!window.location.pathname.startsWith('/products/')) return;

  var IS_TEAM = (document.body.dataset.customerB2b || '').trim() !== '';
  var TEAM_KEYWORD = 'ADDRA Teams';

  function titleText(group) {
    var wrap = group.querySelector('.title_and_price_wrapper');
    return (wrap ? wrap.textContent : group.textContent) || '';
  }

  function isInTemplate(el) {
    return !!el.closest('template');
  }

  function isOneTime(group) {
    return !!group.querySelector('.one_time_purchase_option_app_block');
  }

  function run() {
    try {
      // Gate plan cards — one-time is ALWAYS visible; no default selection
      // (Shopify's native one-time default stands).
      var groups = document.querySelectorAll('.subscription_group');
      groups.forEach(function (group) {
        if (isInTemplate(group)) return;

        // One-time purchase card: never hide.
        if (isOneTime(group)) {
          if (group.style.display !== '') group.style.display = '';
          return;
        }

        var isTeamPlan = titleText(group).indexOf(TEAM_KEYWORD) !== -1;
        // Teams see only the ADDRA Teams plan; public sees only the standard plan.
        var show = IS_TEAM ? isTeamPlan : !isTeamPlan;
        var desired = show ? '' : 'none';
        if (group.style.display !== desired) group.style.display = desired;
      });
    } catch (e) {
      if (window.console) console.warn('[addra-plan-gate]', e);
    }
  }

  var observer = new MutationObserver(run);
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', run);
  run();
})();